import { Formie } from '../libs/formie/js/formie-lib'

export const initFormie = () => {
  
  const forms = document.querySelectorAll('.fui-form')

  if (!forms) return

  const FormieInstance = new Formie()

  forms.forEach(form => FormieInstance.initForm(form))

}